import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import {KTSVG} from '../../../_metronic/helpers'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {ISort, setSort, sipSelector} from '../../../redux/slices/sipSlices'

export const RowHead = () => {
  const {t} = useTranslation()
  const {sort} = useAppSelector(sipSelector)
  const dispatch = useAppDispatch()

  function handleSortSIPNumber() {
    const sipNumber = sort?.sipNumber === 'asc' ? 'desc' : 'asc'
    const customer = ''
    const payload = {...sort, sipNumber, customer}
    dispatch(setSort(payload as ISort))
  }

  function handleSortCustomer() {
    const customer = sort?.customer === 'asc' ? 'desc' : 'asc'
    const sipNumber = ''
    const payload = {...sort, customer, sipNumber}
    dispatch(setSort(payload as ISort))
  }

  /**
   * Action icon sort contract number
   */
  const ActionIconSortSIPNumber = () => {
    const path =
      sort?.sipNumber === 'asc'
        ? '/media/icons/duotune/sort-down-alt.svg'
        : '/media/icons/duotune/sort-up-alt.svg'

    return (
      <button
        className='bg-transparent border-0'
        data-bs-toggle='tooltip'
        data-bs-placement='top'
        title={t('Sort')}
        onClick={handleSortSIPNumber}
      >
        <KTSVG path={path} className='svg-icon-3 ms-1' />
      </button>
    )
  }

  /**
   * Action icon sort customer
   */
  const ActionIconSortCustomer = () => {
    const path =
      sort?.customer === 'asc'
        ? '/media/icons/duotune/sort-down-alt.svg'
        : '/media/icons/duotune/sort-up-alt.svg'

    return (
      <button
        className='bg-transparent border-0'
        data-bs-toggle='tooltip'
        data-bs-placement='top'
        title={t('Sort')}
        onClick={handleSortCustomer}
      >
        <KTSVG path={path} className='svg-icon-3 ms-1' />
      </button>
    )
  }

  return (
    <tr>
      <th>
        {t('No. SIP')}
        <ActionIconSortSIPNumber />
      </th>
      <th>{t('order-no')}</th>
      <th>
        {t('order-pelanggan')}
        <ActionIconSortCustomer />
      </th>
      <th>{t('order-perihal')}</th>
      <th>{t('Sector')}</th>
      <th>Sales Org</th>
      <th>{t('order-tanggal')}</th>
      <th>{t('Tanggal Pengajuan')}</th>
      <th>{t('Start-Date')}</th>
      <th>{t('End-Date')}</th>
      <th>{t('Total Kuantum')}</th>
      <th>{t('Total Price')}</th>
      <th>Status</th>
      <th>{t('order-aksi')}</th>
    </tr>
  )
}

RowHead.defaultProps = {
  role: 'null',
}

export default memo(RowHead)
